import React from "react";
import { Link } from "react-router-dom";
import { Herom, TredningPostsm, TeamInfo, FaqSection, Footer, CommunityStats } from "../components";
import { useSelector } from "react-redux";
import ProfileAlert from "../components/ProfileAlert"; 
import { ROUTES } from "../constants";
import { trackCTAClick } from "../Actions/analytics";

function HomePage() {
  const { user } = useSelector((state) => state.user);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* ── 1. HERO ────────────────────────────────────────────────────────── */}
      <section className="relative pt-32 pb-24 lg:pt-40 lg:pb-32 overflow-hidden bg-[#0A0F1C]">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-20" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[400px] bg-sky-500/20 blur-[120px] rounded-full pointer-events-none" />

        <div className="max-w-7xl mx-auto px-6 relative z-10 text-center">

          {/* Live badge */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 mb-8 text-xs font-bold text-sky-400 bg-sky-500/10 border border-sky-500/20 rounded-full shadow-[0_0_15px_rgba(14,165,233,0.15)]">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-sky-500" />
            </span>
            Live · Interview experiences from 50+ companies
          </div>

          {/* Headline */}
          <h1 className="text-5xl md:text-7xl lg:text-[6rem] font-extrabold tracking-tighter leading-[1.05] mb-8 text-white">
            Welcome back to <br className="hidden md:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-400 via-indigo-400 to-purple-400">
              CampusIRA
            </span>
          </h1>

          <p className="text-lg md:text-xl text-slate-400 font-medium leading-relaxed max-w-3xl mx-auto mb-10">
            Discover and share interview experiences. Join our community to connect, learn, and grow with peers across campuses.
          </p>

          {user && !user.branch && !user.graduationYear && <div className="mb-10"><ProfileAlert /></div>}
        </div>
      </section>
      {/* --- MAIN CONTENT SECTIONS --- */}
      <div className="space-y-10">
        <section className="bg-white">
           <Herom />
        </section>

        {/* Community Stats (The one we made earlier) */}
    

        <section className="bg-gray-50 py-16">
          <TredningPostsm />
        </section>
        
         <CommunityStats />

        <div className="max-w-4xl mx-auto px-6 py-20">
            <FaqSection />
        </div>
      </div>

      {/* ── HIRING / JOIN THE TEAM ─────────────────────────────────────── */}
      <section className="py-24 bg-[#FAFAFA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="relative rounded-[2.5rem] overflow-hidden border border-slate-200 bg-white p-10 md:p-16 flex flex-col md:flex-row items-center justify-between gap-10 shadow-sm">
            <div className="absolute -top-20 -right-20 w-64 h-64 bg-gradient-to-br from-sky-100 to-indigo-100 rounded-full blur-3xl opacity-60 pointer-events-none" />
            <div className="relative z-10 max-w-2xl text-center md:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1 mb-6 text-xs font-bold text-emerald-600 bg-emerald-50 border border-emerald-200 rounded-full">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
                We're hiring interns
              </div>
              <h3 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4 tracking-tight">
                Building CampusIRA is the internship.
              </h3>
              <p className="text-slate-500 text-lg leading-relaxed mb-6">
                We're a small team solving a real problem for 15 lakh engineering
                students every year. If you want to ship production code, own features
                end-to-end, and build something your entire campus will use — not just
                demo projects — there's a spot for you.
              </p>
              <div className="flex flex-wrap gap-2">
                {["Frontend Dev", "Backend Dev", "Full Stack", "UI/UX Design", "AI Integration", "Campus Growth"].map((role) => (
                  <span key={role} className="px-3 py-1.5 rounded-full bg-slate-100 text-slate-600 text-xs font-semibold border border-slate-200">
                    {role}
                  </span>
                ))}
              </div>
            </div>
            <div className="relative z-10 shrink-0 flex flex-col items-center gap-3 w-full md:w-auto">
              <Link to={ROUTES.hiring} onClick={() => trackCTAClick('apply_now_home', ROUTES.hiring)} className="w-full md:w-auto flex items-center justify-center gap-2 bg-slate-900 text-white px-8 py-5 rounded-full font-bold text-base hover:scale-105 hover:bg-slate-800 transition-all shadow-lg group">
                Apply Now
                <span className="group-hover:translate-x-1 transition-transform">→</span>
              </Link>
              <p className="text-xs text-slate-400 font-medium text-center">
                Rolling applications · Respond within 7 days
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default HomePage;